import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useField } from 'formik';
import React, { useState } from 'react';
import './inputWithTitle.scss';

var InputWithTitle = function InputWithTitle(_a) {
  var name = _a.name,
      label = _a.label,
      labelWrapperClassName = _a.labelWrapperClassName,
      labelTabIndex = _a.labelTabIndex,
      inputClassName = _a.inputClassName,
      disabled = _a.disabled,
      className = _a.className,
      labelClassName = _a.labelClassName,
      required = _a.required,
      maxLength = _a.maxLength,
      inputMode = _a.inputMode,
      errorClassName = _a.errorClassName,
      hideErros = _a.hideErros,
      _onChange = _a.onChange,
      _onBlur = _a.onBlur,
      value = _a.value,
      iconClick = _a.iconClick,
      infoButtonLabel = _a.infoButtonLabel,
      infoButtonClassName = _a.infoButtonClassName,
      infoIconClassName = _a.infoIconClassName,
      caption = _a.caption;

  var _b = useField(name),
      field = _b[0],
      meta = _b[1];

  var _c = useState("".concat(infoButtonLabel, " ").concat(label, ".")),
      buttonTitle = _c[0],
      setButtonTitle = _c[1];

  var labelId = "".concat(name, "LabelId");
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(name, "-wrapper"),
    className: "hus-epidemic-input-with-title-wrapper ".concat(className !== null && className !== void 0 ? className : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "hus-epidemic-input-with-title-labelWrapper ".concat(labelWrapperClassName)
  }, required && /*#__PURE__*/React.createElement("span", {
    className: 'hus-epidemic-input-with-title-asterisk',
    "aria-hidden": true
  }, "*"), /*#__PURE__*/React.createElement("label", {
    id: labelId,
    "data-testid": "".concat(name, "-label"),
    className: "hus-epidemic-input-with-title-label ".concat(labelClassName !== null && labelClassName !== void 0 ? labelClassName : '', " ").concat(required ? 'hus-epidemic-input-with-title-required' : ''),
    htmlFor: name,
    tabIndex: labelTabIndex
  }, label), iconClick && /*#__PURE__*/React.createElement("button", {
    id: "".concat(name, "-infoButton"),
    "data-testid": "".concat(name, "-infoButton"),
    type: "button",

    /* eslint-disable */
    role: "application",

    /* eslint-enable */
    className: "hus-epidemic-input-with-title-infoButton ".concat(infoButtonClassName),
    onMouseEnter: function onMouseEnter() {
      return setButtonTitle('');
    },
    onMouseLeave: function onMouseLeave() {
      return setButtonTitle("".concat(infoButtonLabel, " ").concat(label, "."));
    },
    "aria-label": buttonTitle,
    onKeyDown: function onKeyDown(e) {
      if ((e.key === ' ' || e.key === 'Enter') && iconClick) iconClick();
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    id: "".concat(name, "-infoIcon"),
    "data-testid": "".concat(name, "-infoIcon"),
    className: "hus-epidemic-input-with-title-infoIcon ".concat(infoIconClassName),
    icon: faInfoCircle,
    size: "1x",
    "data-for": "tooltip-".concat(name),
    "data-tip": "tooltip",
    onClick: function onClick() {
      return iconClick ? iconClick() : null;
    }
  }))), /*#__PURE__*/React.createElement("input", {
    id: name,
    "data-testid": "".concat(name, "-input"),
    className: "hus-epidemic-input-with-title-input ".concat(inputClassName !== null && inputClassName !== void 0 ? inputClassName : ''),
    type: "text",
    checked: field.checked,
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(e);
      } else {
        field.onChange(e);
      }
    },
    value: value !== null && value !== void 0 ? value : field.value,
    onBlur: function onBlur(e) {
      if (_onBlur) {
        _onBlur(e);
      } else {
        field.onBlur(e);
      }
    },
    name: name,
    disabled: disabled,
    maxLength: maxLength,
    inputMode: inputMode,
    required: required,
    "aria-describedby": "".concat(name, "-error")
  }), !disabled && caption && /*#__PURE__*/React.createElement("div", {
    className: "hus-epidemic-input-with-title-caption"
  }, caption), meta.error && !hideErros ? /*#__PURE__*/React.createElement("div", {
    id: "".concat(name, "-error"),
    "data-testid": "".concat(name, "-error"),
    "aria-live": "polite",
    className: "hus-epidemic-input-with-title-error ".concat(errorClassName)
  }, meta.error) : null);
};

InputWithTitle.defaultProps = {
  className: '',
  label: '',
  labelClassName: '',
  labelWrapperClassName: '',
  labelTabIndex: 0,
  inputClassName: '',
  disabled: false,
  maxLength: undefined,
  inputMode: undefined,
  errorClassName: '',
  hideErros: false,
  onChange: undefined,
  onBlur: undefined,
  value: null,
  iconClick: undefined,
  infoButtonLabel: '',
  infoButtonClassName: '',
  infoIconClassName: '',
  caption: ''
};
export default InputWithTitle;